import script from "./AdminSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminSettings.vue?vue&type=script&setup=true&lang=js"

import "./AdminSettings.vue?vue&type=style&index=0&id=d3315c82&lang=css"

const __exports__ = script;

export default __exports__